import React, { useState, useEffect, useRef } from 'react'
import { CSVLink } from 'react-csv'
import Button from 'components/Button'
import AddIcon from '@material-ui/icons/CloudDownload'
import API from 'api'

function DownloadCsv({ setIsLoading }) {
  const [csvData, setCsvData] = useState(false)
  const csvLinkRef = useRef()
  const currentDate = new Date()
  const parsedDate = `${currentDate.getDate()}-${currentDate.getMonth() +
    1}-${currentDate.getFullYear()}`

  const getAllUsers = async () => {
    try {
      setIsLoading(true)
      const { data } = await new API({ endpoint: `getAllUsers` }).send()
      setIsLoading(false)
      setCsvData(data)
    } catch (error) {
      setCsvData(null)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (csvData && csvLinkRef.current && csvLinkRef.current.link) {
      setTimeout(() => {
        csvLinkRef.current.link.click()
        setCsvData(false)
      })
    }
  }, [csvData])

  return (
    <>
      <Button startIcon={<AddIcon />} variant="contained" color="primary" onClick={getAllUsers}>
        Descargar lista
      </Button>
      {csvData ? (
        <CSVLink
          asyncOnClick={true}
          data={csvData}
          filename={`usuarios-${parsedDate}.csv`}
          ref={csvLinkRef}
        />
      ) : (
        undefined
      )}
    </>
  )
}

export default DownloadCsv
